import * as React from "react"
import {IconSeeker, TabsSeeker} from "@ui-seeker/core";
import {Skeleton} from "@mui/material";

import {TABS_TOP} from "../../@constants";
import {userActivitiesTabID, isLoadingTops, appliedCustomerIDs} from "../../@signals";


export default function UserActivitiesTopTabs() {
    if (isLoadingTops.value.length === 4)
		return <Skeleton variant="rectangular" height={500} />
	if (userActivitiesTabID.value === null)
		return <></>

	const countriesIsLoading = isLoadingTops.value.includes(TABS_TOP.MARKETS)
	const usersIsLoading = isLoadingTops.value.includes(TABS_TOP.USERS)
	const dashboardIsLoading = isLoadingTops.value.includes(TABS_TOP.DASHBOARD)
	const customersIsLoading = isLoadingTops.value.includes(TABS_TOP.CUSTOMERS)

    const tabs = [
        {
            disabled: countriesIsLoading,
            label: 'By Markets',
            value: TABS_TOP.MARKETS,
            icon: countriesIsLoading ? <IconSeeker isSpin icon="spinner" /> : <IconSeeker icon="earth-europe" />,
        }, {
            disabled: usersIsLoading,
            label: 'By Users',
            value: TABS_TOP.USERS,
            icon: usersIsLoading ? <IconSeeker isSpin icon="spinner" /> : <IconSeeker icon="user" />,
        }, {
            disabled: dashboardIsLoading,
            label: 'By Dashboards',
            value: TABS_TOP.DASHBOARD,
            icon: dashboardIsLoading ? <IconSeeker isSpin icon="spinner" /> : <IconSeeker icon="table-columns" />,
        }
    ]

    if (appliedCustomerIDs.value.length !== 1) {
        tabs.push({
            disabled: customersIsLoading,
            label: 'By Customers',
            value: TABS_TOP.CUSTOMERS,
            icon: customersIsLoading ? <IconSeeker isSpin icon="spinner" /> : <IconSeeker icon="users" />,
        })
    }


    return <TabsSeeker
		showTabID={userActivitiesTabID.value}
		onChange={(_, newValue) => userActivitiesTabID.value = newValue || TABS_TOP.MARKETS}
		tabs={tabs}
	/>
}